import { useEffect } from 'react'

import { useDispatch } from 'react-redux'

import { setTimezone, guessTimezone } from '../redux/modules/timezone'

export const useTimezone = timezone => {
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(timezone ? setTimezone(timezone) : guessTimezone())
  }, [])
}
